import React, { useCallback, useRef, useState } from 'react'

// Manages the hidden file input and the list of attached files.
const useFileAttachments = () => {
  const [files, setFiles] = useState<File[]>([])
  const fileInputRef = useRef<HTMLInputElement | null>(null)

  const handleFileSelect = useCallback(() => fileInputRef.current?.click(), [])

  const handleFilesChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files
    if (selected) {
      setFiles((prev) => [...prev, ...Array.from(selected)])
    }
    e.target.value = ''
  }, [])

  const handleRemoveFile = useCallback((index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index))
  }, [])

  const resetFiles = useCallback(() => setFiles([]), [])

  return { files, fileInputRef, handleFileSelect, handleFilesChange, handleRemoveFile, resetFiles }
}

export default useFileAttachments
